export default __webpack_public_path__ + "static/media/Banner-Bosque-Capital.4970c5ba.png";